import { toast } from "react-toastify";
import apiService from "../../service/Api";

const JOB_CARD_FRONTEND_URL =
  process.env.REACT_APP_JOB_CARD_FRONTEND_URL || "http://localhost:5173";

interface IssueResponse {
  code: string;
}

interface ApiErrorShape {
  response?: { data?: { message?: string } };
}

export async function issueJobCardSsoCode(): Promise<string> {
  const response = await apiService.post<IssueResponse>(
    "/api/authentication/sso/issue/",
    { target: "job_card" },
  );
  return response.data.code;
}

export function openJobCard() {
  const newTab = window.open("", "_blank");

  issueJobCardSsoCode()
    .then((code) => {
      const url = `${JOB_CARD_FRONTEND_URL}/sso?code=${code}`;
      if (newTab) {
        newTab.location.href = url;
      } else {
        window.location.href = url;
      }
    })
    .catch((err: unknown) => {
      newTab?.close();
      const message =
        (err as ApiErrorShape)?.response?.data?.message ||
        "Could not open Job Card. Please try again.";
      toast.error(message);
    });
}
